import BaseModel from '../core/BaseModel';

export default class SettingsModel extends BaseModel {

    constructor() {
        super({
            name: "setting",
            tableName: 'setting',
            label: "Settings",
        }, {
            id: {
                name: 'id',
                type: "Uuid",
                label: 'ID',
                primaryKey: true,
                display: false
            },
            key: {
                name: 'key',
                type: "String",
                label: 'Key',
                width: 15,
                filter: { type: 'input', match: 'contains' },
            },
            value: {
                name: 'value',
                type: "String",
                label: 'Value',
                width: 15,
                filter: { type: 'input', match: 'contains' },
            },
  
        })
    }
}
